export default {
  fundDetail: '资金明细',
  tradeStartDate: '交易开始日',
  tradeEndDate: '交易结束日',
  tradeNo: '交易编号',
  recharge: '充值',
  rechargeLog: '充值记录',
  relationOrderNo: '关联订单号',
  tradeIntro: '交易说明',
  tradeTime: '交易时间',
  tradeType: '交易类型',
  amount: '金额',
  balance: '余额',
  payPack: '装箱单付款',
  payOrder: '订单付款',
  compensate: '赔偿',
  deduct: '扣款',
  withdrawal: '退金（提现）',
  fund1: '购买完扣费',
  fund2: '退货退费',
  fund3: '异常扣费',
  fund4: '同捆付款',
  fund5: '仓库保管费',
  fund6: '检品完扣费',
  fund7: '账单付款',
  fund8: '取消购买退费',
  fund9: '取消检品退费',
  fund10: '会员费扣费',
  fund11: '充值手续费',
  fund12: '订单ID',
  fund13: '请输入订单ID',
};
